import *as React from 'react';
import { ShadDonutTextChart } from "../ShadDonutTextChart";

import { addDays, eachWeekOfInterval, subDays } from "date-fns"

const desktopData = [
    { month: "january", desktop: 0, fill: "var(--color-january)" },
    { month: "february", desktop: 0, fill: "var(--color-february)" },
    { month: "march", desktop: 0, fill: "var(--color-march)" },
    { month: "april", desktop: 0, fill: "var(--color-april)" },
    { month: "may", desktop: 0, fill: "var(--color-may)" },
    { month: "june", desktop: 0, fill: "var(--color-june)" },
    { month: "july", desktop: 0, fill: "var(--color-july)" },
]

const chartConfig = {
    visitors: {
        label: "Visitors",
    },
    desktop: {
        label: "Desktop",
    },
    mobile: {
        label: "Mobile",
    },
    january: {
        label: "January",
        color: "hsl(var(--chart-1))",
    },
    february: {
        label: "February",
        color: "hsl(var(--chart-2))",
    },
    march: {
        label: "March",
        color: "hsl(var(--chart-3))",
    },
    april: {
        label: "April",
        color: "hsl(var(--chart-4))",
    },
    may: {
        label: "May",
        color: "hsl(var(--chart-5))",
    },
    june: {
        label: "June",
        color: "hsl(var(--chart-6))",
    },
    july: {
        label: "July",
        color: "hsl(var(--chart-7))",
    },
};

const AtarimDonutTextchart = ({ data, deviceNames, donutDeviceName, setDonutDeviceName }) => {
    const defaultDesktopData = [
        { month: "january", desktop: 0, fill: "var(--color-january)" },
        { month: "february", desktop: 0, fill: "var(--color-february)" },
        { month: "march", desktop: 0, fill: "var(--color-march)" },
        { month: "april", desktop: 0, fill: "var(--color-april)" },
        { month: "may", desktop: 0, fill: "var(--color-may)" },
        { month: "june", desktop: 0, fill: "var(--color-june)" },
        { month: "july", desktop: 0, fill: "var(--color-july)" },
    ];

    const { desktopData, currentWeekValue, weeklyDifference } = React.useMemo(() => {
        if (!data || data.length === 0) {
            return { desktopData: defaultDesktopData, currentWeekValue: 0, weeklyDifference: 0 };
        }

        const dateRangeSundays = eachWeekOfInterval({
            start: new Date(data[0]?.date),
            end: new Date(data[data.length - 1]?.date)
        });

        if (dateRangeSundays.length < 3) {
            return { desktopData: defaultDesktopData, currentWeekValue: 0, weeklyDifference: 0 };
        }

        let lastSundayDate = dateRangeSundays[dateRangeSundays.length - 2];
        let lastToLastSundayDate = dateRangeSundays[dateRangeSundays.length - 3];
        let lastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length - 1], 1);
        let lastToLastSaturdayDate = subDays(dateRangeSundays[dateRangeSundays.length - 2], 1);

        const result = data.reduce((acc, curr) => {
            const dateOnly = curr.date ? String(curr.date).split("T")[0] : "";
            if (dateOnly) {
                acc[dateOnly] = (acc[dateOnly] || 0) + (curr.entering || 0);
            }
            return acc;
        }, {});

        const formattedResult = Object.entries(result).map(([date, enteringSum]) => ({
            date,
            enteringSum
        }));

        const localDesktopData = defaultDesktopData.map(item => ({ ...item }));
        const currentSlice = formattedResult.filter(fr => {
            const d = new Date(fr.date);
            return d >= new Date(lastSundayDate) && d <= new Date(lastSaturdayDate);
        });

        currentSlice.forEach((element, i) => {
            if (localDesktopData[i]) {
                localDesktopData[i].month = new Date(element.date).toLocaleString('he-IL', { day: 'numeric', month: 'short', weekday: 'short' });
                localDesktopData[i].desktop = element.enteringSum;
            }
        });

        const curVal = localDesktopData.reduce((acc, item) => acc + item.desktop, 0);
        const lastSlice = formattedResult.filter(fr => {
            const d = new Date(fr.date);
            return d >= new Date(lastToLastSundayDate) && d <= new Date(lastToLastSaturdayDate);
        });
        const lastVal = lastSlice.reduce((acc, item) => acc + item.enteringSum, 0);
        const diff = curVal - lastVal;

        return { desktopData: localDesktopData, currentWeekValue: curVal, weeklyDifference: diff };
    }, [data]);

    return (
        <ShadDonutTextChart
            data={data}
            deviceNames={deviceNames}
            donutDeviceName={donutDeviceName}
            setDonutDeviceName={setDonutDeviceName}
            currentWeekValue={currentWeekValue}
            chartConfig={chartConfig}
            weeklyDifference={weeklyDifference}
            desktopData={desktopData}
            chartDescription="סה״כ אנשים שנכנסו בשבוע החולף"
        />
    );
};

export default AtarimDonutTextchart;